import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import { IMAGES, COURSES } from '../data/mock';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import TrialCTA from '../components/TrialCTA';

export default function Cours() {
  return (
    <>
      <PageHero
        eyebrow="Nos cours"
        title="Une prog"
        accent="universelle"
        img="hxRunFinish"
        subtitle="Une seule programmation, adaptée à tous les niveaux — du débutant au compétiteur. Elle s'articule autour de blocs complémentaires pour te préparer à chaque obstacle de l'Hyrox."
      />

      <section className="py-14 md:py-28 max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-3xl mb-12">
          <p className="hx-eyebrow mb-4">La programmation</p>
          <h2 className="font-display text-3xl md:text-5xl leading-[0.95]">Les blocs de ta semaine</h2>
          <p className="text-[var(--hx-muted)] mt-5 leading-relaxed">
            Chaque bloc cible une qualité précise. Mis bout à bout sur la semaine, ils couvrent tout ce dont tu as besoin pour performer le jour J — quel que soit ton niveau.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {COURSES.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 100}>
              <div className="hx-card group rounded-md overflow-hidden h-full flex flex-col">
                <div className="h-52 overflow-hidden relative">
                  <img src={IMAGES[c.img]} alt={c.name} loading="lazy" decoding="async" style={{ objectPosition: c.objectPos || 'center' }} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#131313] to-transparent" />
                  <h3 className="absolute bottom-4 left-5 right-5 font-display text-2xl group-hover:text-accent transition-colors">{c.name}</h3>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <p className="text-[var(--hx-muted)] text-sm leading-relaxed flex-1">{c.desc}</p>
                  <Link to="/reserver" className="inline-flex items-center gap-1 text-accent font-cond text-sm tracking-wider mt-5">
                    Réserver <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <TrialCTA />
    </>
  );
}
